import { InstantAnswerContext } from "@faire/help-center-self-serve/types";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalOrders from "@faire/web-api--source/routes/www/brand-portal/orders";
import brandPortalOrdersbrandOrderToken from "@faire/web-api--source/routes/www/brand-portal/orders/brandOrderToken";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";

interface IRequestCommissionChangesIAProps {
  context: InstantAnswerContext;
}

export const RequestCommissionChangesIA: React.FC<
  IRequestCommissionChangesIAProps
> = ({ context }) => {
  const brandOrderToken = context.brandOrder?.brand_order?.token;
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="We’re happy to update an order to 0% commission when you provide documentation of your relationship with an eligible retailer. This documentation can be submitted by going to the <OrderDetailsLinkFormatting>Order details page</OrderDetailsLinkFormatting> and navigating to <BoldFormatting>Request commission change</BoldFormatting>."
          values={{
            BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
            OrderDetailsLinkFormatting: (chunks: JSX.Element) =>
              OrderLinkFormatting(chunks, brandOrderToken),
          }}
          description={{
            img: "https://cdn.faire.com/fastly/0fbb053871997208eb7925ae63d9fb541c7fcfe0f42c5bd0c474a140fa565f7a.png",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Once submitted, our team will review your request and provide you with an update via email within 2 business days. If your commission update request is approved, you’ll receive updated commission on this order and all subsequent orders from this customer."
          values={{
            BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
          }}
          description={{
            img: "https://cdn.faire.com/fastly/0fbb053871997208eb7925ae63d9fb541c7fcfe0f42c5bd0c474a140fa565f7a.png",
          }}
        />
      </Typography>
    </Column>
  );
};

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;

const OrderLinkFormatting = (chunks: JSX.Element, brandOrderToken?: string) => {
  if (!brandOrderToken) {
    return (
      <Button variant="tertiary" linkTo={brandPortalOrders()} target="_blank">
        <Bold>{chunks}</Bold>
      </Button>
    );
  } else {
    return (
      <Button
        variant="tertiary"
        linkTo={brandPortalOrdersbrandOrderToken(brandOrderToken)}
        target="_blank"
      >
        <Bold>{chunks}</Bold>
      </Button>
    );
  }
};
